import {Box, Button, Slide, Stack, Toolbar, Typography} from "@mui/material";
import avatarImg from "../../../assets/images/agent.png";
import {AIAnimation} from "../../../components/lottie-animations/AIAnimation";

export const WelcomeBanner = () => {

  return (
    <Stack
      direction={"column"}
      sx={{p: {xs: 2, md: 6}, pt: "24px !important", height: "calc(100dvh - 64px)"}}
    >
      <Toolbar/>
      <Stack direction={"row"} gap={2}
             sx={{borderRadius: "24px", bgcolor: "primary.light", flex: 1, position: "relative"}}>
        <Stack direction={"column"} alignItems={{xs:"center", md: "flex-start", lg: "center"}} justifyContent={{xs: "flex-end", sm: "flex-start", md: "center"}} sx={{p: {xs: 2, md: 4}, flex: 1}}>
          <Slide in={true} direction={"right"} timeout={1000}>
            <Stack direction={"column"} gap={2} maxWidth={"sm"} justifyContent={"center"}
                   sx={{
                     p: {xs: 2, md: 4},
                     width: "90%",
                     zIndex: 3,
                     borderRadius: "18px",
                     bgcolor: {xs: "#fefefe33", md: "#fefefe33"},
                     backdropFilter: "blur(4px)"
                   }}>
              <Typography fontSize={{xs: "1.1em", md: "1.6em"}} fontWeight={500} color={"#ffffff"}>
                Reduce Contact Center Workload by <span style={{fontWeight: 600}}>50-70%</span> with AI-Powered Call
                Handling
              </Typography>
              <Typography fontSize={{xs: "0.85em", md: "1em"}} fontWeight={300} color={"#ffffff"}>
                Our AI Agent handles inbound calls, resolves queries, and reduces human agent workload instantly.
              </Typography>
              <Box>
                <Button
                  size={"large"}
                  sx={{
                    bgcolor: "#fefefe",
                    borderRadius: 3,
                    fontSize: {xs: "0.9em", md: "1.1em"},
                    "&:hover": {
                      bgcolor: "#ffffff",
                      transform: "scale(1.025)"
                    }
                  }}
                  onClick={() => {
                    const div = document.getElementById("contact-us");
                    if (div) {
                      div?.scrollIntoView({behavior: "smooth", block: "center"})
                    }
                  }}
                >
                  Get a Free Demo
                </Button>
              </Box>
            </Stack>
          </Slide>
        </Stack>
        <Stack sx={{flex: 1, display: {xs: "none", lg: "flex"}}}></Stack>
        <Slide in={true} direction={"left"} timeout={1000}>
          <Box
            sx={{
              position: "absolute", bottom: -3, right: {xs: 30, md: 100},
              maxWidth: {xs: "350px", md: "400px", lg: "450px"}, zIndex: 2,
              "& > img": {
                width: {xs: "100%", md: "400px", lg: "450px"}
              }
            }}
          >
            <img src={avatarImg} alt={"avatar"} width="100%" height="100%"/>
            {/*<RobotAnimation width={400} height={400} />*/}
          </Box>
        </Slide>
        <Stack alignItems={"center"} justifyContent={"center"} sx={{position: "absolute", left: 0, right: {xs: 0, sm: "50%", md: 0}, top: 0, bottom: {xs: "50%", sm: 0}, borderRadius: "inherit", opacity: 0.2}}>
          {/*<img src={bgImage} width={"100%"} height={"100%"} style={{objectFit: "cover", borderRadius: "inherit"}} />*/}
          <AIAnimation width={300} height={300} />
        </Stack>
        <Box
          sx={{
            position: "absolute", top: 10, left: 10,
            bgcolor: "#fefefe33",
            minWidth: "300px", minHeight: "300px",
            width: "25vw", height: "25vw", borderRadius: "50%",
            transform: "translate(-30%, -30%)"
          }}
        >
        </Box>
        <Box
          sx={{
            position: "absolute", bottom: 10, left: 10,
            bgcolor: "#fefefe33",
            width: "200px", height: "200px", borderRadius: "50%",
            transform: "translate(-30%, 30%)"
          }}
        >
        </Box>
        <Box
          sx={{
            position: "absolute", bottom: 10, right: 10,
            bgcolor: "#fefefe33",
            minWidth: "300px", minHeight: "300px",
            width: "35vw", height: "35vw", borderRadius: "50%",
            transform: "translate(30%, 30%)"
          }}
        >
        </Box>
      </Stack>
    </Stack>
  )
}